import { Form, Icon, Tooltip } from 'antd';
import React, { useEffect } from 'react';
import { fieldNames } from '../../../common/config';
import useCompanies from '../../../../../../../queries/useCompanies';
import { getOptionsBySelect } from '../../lib/getOptionsBySelect';
import DropdownSelect from '../../../../../../../components/dropdownSelect';
import { getRenderControl } from '../../../../../../../components/SingleControlCustom/getRenderControl';

const companyFieldName = fieldNames.company;
const cityFieldName = fieldNames.city;
const FormItem = Form.Item;

const CompanyField = ({ form }) => {
  const { data: companies = [], isFetching } = useCompanies({
    staleTime: Infinity,
  });

  const loading = Boolean(isFetching);
  const disabled = Boolean(
    loading ||
      !companies ||
      (companies.length === 1 && form.getFieldValue(companyFieldName))
  );

  const options = getOptionsBySelect(companies);

  const handleCompanyChange = (value) => {
    form.setFieldsValue({
      [companyFieldName]: value,
      [cityFieldName]: null,
    });
  };

  useEffect(() => {
    if (
      companies &&
      companies.length === 1 &&
      !form.getFieldValue(companyFieldName)
    ) {
      form.setFieldsValue({ [companyFieldName]: companies[0].id });
    }
  }, [companies]);

  return (
    <FormItem
      style={{ margin: 0 }}
      label={
        <span>
          Компания&nbsp;
          <Tooltip title="На основе компании формируются список городов, адреса и ответственные лица">
            <Icon
              type="info-circle"
              style={{ fontSize: '16px' }}
            />
          </Tooltip>
        </span>
      }
    >
      {form.getFieldDecorator(companyFieldName, {
        rules: [
          {
            required: true,
            message: 'Укажите УК',
          },
        ],
      })(
        <DropdownSelect
          onChange={handleCompanyChange}
          multiple={false}
          options={options}
          renderControl={getRenderControl({
            options: options,
            isClear: false,
            value: form.getFieldValue(companyFieldName),
            disabled,
            loading,
          })}
        />
      )}
    </FormItem>
  );
};

export default CompanyField;
